var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ScrollFog_instances, _ScrollFog_scrollableElement, _ScrollFog_targetElement, _ScrollFog_update;
class ScrollFog {
    constructor(scrollableElement, targetElement) {
        _ScrollFog_instances.add(this);
        _ScrollFog_scrollableElement.set(this, void 0);
        _ScrollFog_targetElement.set(this, void 0);
        if (!scrollableElement)
            throw new Error('ScrollFog: scrollableElement element is not found');
        if (!targetElement)
            throw new Error('ScrollFog: targetElement element is not found');
        __classPrivateFieldSet(this, _ScrollFog_scrollableElement, scrollableElement, "f");
        __classPrivateFieldSet(this, _ScrollFog_targetElement, targetElement, "f");
        __classPrivateFieldGet(this, _ScrollFog_instances, "m", _ScrollFog_update).call(this);
        __classPrivateFieldGet(this, _ScrollFog_scrollableElement, "f").addEventListener('scroll', () => __classPrivateFieldGet(this, _ScrollFog_instances, "m", _ScrollFog_update).call(this), {
            passive: true,
        });
    }
}
_ScrollFog_scrollableElement = new WeakMap(), _ScrollFog_targetElement = new WeakMap(), _ScrollFog_instances = new WeakSet(), _ScrollFog_update = function _ScrollFog_update() {
    const { scrollLeft, scrollWidth, clientWidth } = __classPrivateFieldGet(this, _ScrollFog_scrollableElement, "f");
    __classPrivateFieldGet(this, _ScrollFog_targetElement, "f").classList.toggle('has-fog-left', scrollLeft > 0);
    __classPrivateFieldGet(this, _ScrollFog_targetElement, "f").classList.toggle('has-fog-right', scrollLeft + clientWidth < scrollWidth - 1);
};
export default ScrollFog;
